import Reveal from '@/components/feature/Reveal';
import SectionHeading from './SectionHeading';
import { channels, processSteps } from '@/mocks/guide';

export default function ProcessSection() {
  return (
    <section id="process" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="CHANNELS & FLOW"
          title="投稿渠道与流程：选对入口，四步走完"
          desc="爆料51 提供三个投稿渠道，按材料体量与敏感程度选择即可。无论走哪条渠道，流程都是同样的四步。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {channels.map((channel, index) => (
            <Reveal key={channel.name} delay={index * 90}>
              <article className="h-full flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 transition-colors hover:border-secondary-400">
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${channel.icon} text-2xl`} aria-hidden="true" />
                  </span>
                  <span className="text-xs text-foreground-400 tracking-widest">0{index + 1}</span>
                </div>
                <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">{channel.name}</h3>
                <p className="mt-1 text-xs text-secondary-700 bg-secondary-100 inline-block self-start px-2 py-1 rounded-md">
                  {channel.fit}
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{channel.detail}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={60}>
          <div className="mt-12 md:mt-16 p-6 md:p-8 rounded-lg bg-accent-950">
            <div className="flex items-center gap-2 text-accent-300 text-sm tracking-[0.18em] mb-6">
              <span className="w-6 h-px bg-accent-400"></span>
              STEP BY STEP
            </div>
            <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {processSteps.map((item) => (
                <li key={item.step} className="relative flex flex-col p-5 rounded-lg bg-background-50/5 border border-background-50/10">
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 font-heading font-bold text-sm">
                      {item.step}
                    </span>
                    <span className="h-px flex-1 bg-background-50/15"></span>
                  </div>
                  <h3 className="mt-4 font-heading font-semibold text-base md:text-lg text-background-50">{item.title}</h3>
                  <p className="mt-2 text-sm text-background-300 leading-relaxed flex-1">{item.desc}</p>
                  <p className="mt-4 flex items-start gap-1.5 text-xs text-primary-300 leading-snug">
                    <i className="ri-lightbulb-line mt-0.5 shrink-0" aria-hidden="true" />
                    {item.tip}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </Reveal>
      </div>
    </section>
  );
}